export const mockData = {
  site: {
    name: 'Lyfe Simply',
    tagline: 'Helping Power Gain In Their Life',
    subtagline: 'Relate to each other from the best of you',
    email: 'admin@lyfesimply.com',
    phone: '+971 50 525 0093',
    timing: '9 am to 6 pm',
    logo: 'https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=200&h=200&fit=crop'
  },
  
  hero: {
    title: 'Helping Power Gain In Their Life',
    subtitle: 'Relate to each other from the best of you',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1920&h=800&fit=crop',
    cta: 'Contact Us'
  },

  about: {
    name: "Jacky",
    title: "Therapist & Life Coach",
    image: "https://customer-assets.emergentagent.com/job_lyfeclone/artifacts/52fa0fir_Screenshot%202025-11-11%20144956.png",
    image_url: "https://customer-assets.emergentagent.com/job_lyfeclone/artifacts/52fa0fir_Screenshot%202025-11-11%20144956.png",
    subtitle: 'About me',
    description: `Born and raised in the U.A.E and graduated with a B.E (Hons) degree in Electrical and Electronic Engineering and a MBA from University of Bradford. After having given 10 years to the corporate industry, climbing the corporate ladder, with a position of Branch Manager at an International Company as my last corporate job. At this point, as moth gets drawn to light, I started on my quest on finding answers to deeper questions about myself.

As I went on understanding myself better while peeling each layer of self, I realized I was looking at spirituality in the eye. Not the spirituality of religion but of science.`,
    instagram: '#',
    youtube: '#'
  },

  lyfeSimply: {
    title: 'Simplifying Lives',
    subtitle: 'Welcome to Lyfe Simply',
    description: `If the anatomy of a human body were to be studied, one would have to study different complex systems that are singularly functional and yet interdependent on other systems, further breaking down the structures to tissues and cells would involve studies of even complex hydrocarbon. And yet, if one were to consider the one element that keeps the entire system i.e our human body, alive is simply breathing! Taking in air and giving out air. Simple breathing without which all the organs would fail to function eventually. And the task of this mechanism of breathing is so simple that it is even involuntary. Breathing is one of the very few bodily functions that we do voluntarily as much as involuntarily, we don't even have to remind ourselves to breathe. So if the one function that keeps us alive is so simple, how could life itself be complicated?`,
    image: 'https://images.unsplash.com/photo-1604881991720-f91add269bed?w=700&h=500&fit=crop',
    philosophy: 'At Lyfe Simply, we take you through all the complications in your life, in the order to reach its simplicity. Based on the philosophy that You create your own reality, and the universe around is simply a projection of the reality you have created.'
  },

  services: [
    {
      id: 1,
      title: 'Therapies',
      description: 'Our integrated approach of therapies will facilitate your ability towards changing your own reality, which is also empowering.',
      image: 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?w=600&h=400&fit=crop',
      link: '/therapies',
      features: ['Hypnotherapy', 'Past Life Regression', 'Life Coaching', 'Stress & Anxiety Management', 'Weight Management', 'Smoking Cessation']
    },
    {
      id: 2,
      title: 'Trainings',
      description: 'Transform your career and help others by becoming a certified therapist. Learn powerful techniques that change lives.',
      image: 'https://images.unsplash.com/photo-1541976844346-f18aeac57b06?w=600&h=400&fit=crop',
      link: '/trainings',
      features: ['Clinical Hypnotherapy', 'Hypnobirthing Certification', 'Life Coaching', 'NLP Practitioner', 'Advanced Techniques']
    }
  ],

  testimonials: [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Corporate Professional',
      content: 'Life changing experience! The hypnotherapy sessions helped me overcome my anxiety and find peace within myself.',
      video: '',
      image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300&h=300&fit=crop',
      rating: 5
    },
    {
      id: 2,
      name: 'Michael Roberts',
      role: 'Entrepreneur',
      content: 'The training program was exceptional. I am now a certified hypnotherapist helping people transform their lives.',
      video: '',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300&h=300&fit=crop',
      rating: 5
    },
    {
      id: 3,
      name: 'Emma Williams',
      role: 'Life Coach',
      content: 'Jacky\'s approach to therapy is unique and effective. I have seen remarkable changes in my clients after applying these techniques.',
      video: '',
      image: 'https://images.unsplash.com/photo-1551847677-dc82d764e1eb?w=300&h=300&fit=crop',
      rating: 5
    }
  ],

  events: [
    {
      id: 1,
      title: 'Clinical Hypnotherapy Certification',
      date: '2025-02-15',
      duration: '3 Months',
      mode: 'Online & In-Person',
      price: 'AED 12,000',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=500&h=300&fit=crop',
      description: 'Comprehensive certification program in clinical hypnotherapy',
      featured: true
    },
    {
      id: 2,
      title: 'Stress Management Workshop',
      date: '2025-01-20',
      duration: '1 Day',
      mode: 'In-Person',
      price: 'AED 500',
      image: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?w=500&h=300&fit=crop',
      description: 'Learn effective techniques to manage stress and anxiety',
      featured: false
    },
    {
      id: 3,
      title: 'Hypnobirthing Training',
      date: '2025-03-10',
      duration: '2 Weeks',
      mode: 'Online',
      price: 'AED 8,000',
      image: 'https://images.pexels.com/photos/4098370/pexels-photo-4098370.jpeg?w=500&h=300&fit=crop',
      description: 'Become a certified hypnobirthing practitioner',
      featured: true
    }
  ],

  reviews: [
    {
      id: 1,
      name: 'David Chen',
      rating: 5,
      comment: 'Exceptional service and life-changing results. Highly recommended!',
      date: '2024-12-10'
    },
    {
      id: 2,
      name: 'Lisa Anderson',
      rating: 5,
      comment: 'Professional, caring, and truly transformative experience.',
      date: '2024-12-05'
    },
    {
      id: 3,
      name: 'James Wilson',
      rating: 5,
      comment: 'Best investment in myself. The therapy sessions were incredible.',
      date: '2024-11-28'
    },
    {
      id: 4,
      name: 'Sophie Brown',
      rating: 5,
      comment: 'Amazing experience! I feel like a new person after the sessions.',
      date: '2024-11-20'
    }
  ],

  therapies: [
    {
      id: 1,
      title: 'Hypnotherapy',
      description: 'Access your subconscious mind to create lasting positive changes in your life.',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop',
      benefits: ['Overcome fears and phobias', 'Reduce stress and anxiety', 'Improve sleep quality', 'Break unwanted habits'],
      duration: '60-90 minutes',
      price: 'AED 500'
    },
    {
      id: 2,
      title: 'Past Life Regression',
      description: 'Explore past life experiences to understand and resolve current life challenges.',
      image: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?w=600&h=400&fit=crop',
      benefits: ['Understand life patterns', 'Heal emotional trauma', 'Discover life purpose', 'Release karmic blocks'],
      duration: '90-120 minutes',
      price: 'AED 800'
    },
    {
      id: 3,
      title: 'Life Coaching',
      description: 'Personalized coaching to help you achieve your goals and live your best life.',
      image: 'https://images.unsplash.com/photo-1541976844346-f18aeac57b06?w=600&h=400&fit=crop',
      benefits: ['Set and achieve goals', 'Improve relationships', 'Career advancement', 'Personal growth'],
      duration: '60 minutes',
      price: 'AED 400'
    },
    {
      id: 4,
      title: 'Weight Management',
      description: 'Holistic approach to achieve and maintain your ideal weight through mindset transformation.',
      image: 'https://images.pexels.com/photos/4098370/pexels-photo-4098370.jpeg?w=600&h=400&fit=crop',
      benefits: ['Sustainable weight loss', 'Healthy eating habits', 'Body image improvement', 'Emotional eating resolution'],
      duration: '60 minutes',
      price: 'AED 450'
    },
    {
      id: 5,
      title: 'Smoking Cessation',
      description: 'Break free from smoking addiction using powerful hypnotherapy techniques.',
      image: 'https://images.pexels.com/photos/5878483/pexels-photo-5878483.jpeg?w=600&h=400&fit=crop',
      benefits: ['Quit smoking permanently', 'Manage cravings', 'Improve health', 'Save money'],
      duration: '90 minutes',
      price: 'AED 600'
    },
    {
      id: 6,
      title: 'Stress & Anxiety Management',
      description: 'Learn effective techniques to manage stress and live a peaceful, balanced life.',
      image: 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?w=600&h=400&fit=crop',
      benefits: ['Reduce anxiety', 'Improve mental clarity', 'Better sleep', 'Enhanced well-being'],
      duration: '60 minutes',
      price: 'AED 400'
    }
  ],

  trainings: [
    {
      id: 1,
      title: 'Clinical Hypnotherapy Certification',
      description: 'Comprehensive training program to become a certified clinical hypnotherapist.',
      image: 'https://images.unsplash.com/photo-1541976844346-f18aeac57b06?w=600&h=400&fit=crop',
      duration: '3 Months',
      modules: 12,
      certification: 'International Certification',
      price: 'AED 12,000',
      syllabus: ['Fundamentals of Hypnosis', 'Induction Techniques', 'Therapeutic Applications', 'Ethics and Practice Management']
    },
    {
      id: 2,
      title: 'Hypnobirthing Practitioner',
      description: 'Learn to teach expectant mothers the art of calm, peaceful birthing.',
      image: 'https://images.pexels.com/photos/4098370/pexels-photo-4098370.jpeg?w=600&h=400&fit=crop',
      duration: '2 Weeks',
      modules: 8,
      certification: 'Certified Hypnobirthing Practitioner',
      price: 'AED 8,000',
      syllabus: ['Hypnobirthing Philosophy', 'Relaxation Techniques', 'Teaching Methodology', 'Business Setup']
    },
    {
      id: 3,
      title: 'NLP Practitioner',
      description: 'Master Neuro-Linguistic Programming techniques for personal and professional development.',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop',
      duration: '1 Month',
      modules: 10,
      certification: 'Certified NLP Practitioner',
      price: 'AED 10,000',
      syllabus: ['NLP Principles', 'Language Patterns', 'Behavioral Change', 'Advanced Techniques']
    },
    {
      id: 4,
      title: 'Life Coaching Certification',
      description: 'Transform lives as a certified life coach with proven methodologies.',
      image: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?w=600&h=400&fit=crop',
      duration: '2 Months',
      modules: 8,
      certification: 'Certified Life Coach',
      price: 'AED 9,000',
      syllabus: ['Coaching Fundamentals', 'Goal Setting Techniques', 'Communication Skills', 'Practice Building']
    }
  ],

  vlogs: [
    {
      id: 1,
      title: 'Understanding Hypnotherapy',
      description: 'An introduction to the science and practice of hypnotherapy.',
      thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop',
      videoUrl: '',
      duration: '10:24',
      date: '2024-12-01',
      category: 'Education'
    },
    {
      id: 2,
      title: 'Managing Stress in Modern Life',
      description: 'Practical tips and techniques for stress management.',
      thumbnail: 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?w=600&h=400&fit=crop',
      videoUrl: '',
      duration: '8:15',
      date: '2024-11-28',
      category: 'Wellness'
    },
    {
      id: 3,
      title: 'The Power of Meditation',
      description: 'How meditation can transform your life and mind.',
      thumbnail: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?w=600&h=400&fit=crop',
      videoUrl: '',
      duration: '12:30',
      date: '2024-11-20',
      category: 'Mindfulness'
    }
  ]
};
